import {Module} from './module';
export const module = new Module();